import window from 'window-or-global';
import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';

export const matchRoadmapUri = (source) => {
	return /^http[s]?:\/\/.*\/secure\/Roadmap\.jspa.*(\?|&)projectKey=([\w][\w]+)/g.exec(source);
};

const jiraRoadmapPaste = {
	pasteHandler(uri, node, done) {
		const { source } = uri;
		const {
			context: { activeElement = null },
		} = node;
		let macro = null;
		const match = matchRoadmapUri(source);
		/**
		 * auto-convert of jiraroadmap macro will only be enabled in page edit.
		 * We want to avoid auto-convert in page comment and inline-comment sections.
		 *
		 * We check the the diff of the classList:
		 * Comment sections have this class: 'resizable'
		 * Page edit has these classes: 'fullsize', 'page-edit'
		 */
		if (match && activeElement && activeElement.classList.contains('page-edit')) {
			macro = {
				name: 'jiraroadmap',
				params: {
					url: source,
				},
			};
		}

		if (macro) {
			window.tinymce.plugins.Autoconvert.convertMacroToDom(macro, done, done);
		} else {
			done();
		}
	},
};

export default function jiraRoadmapPasteLink() {
	bind('init.rte', () => {
		window.tinymce.plugins.Autoconvert.autoConvert.addHandler(jiraRoadmapPaste.pasteHandler);
	});
}
